import { Component, OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { ProfileCustomField } from '../../shared/model/profile-custom-field.model';
import { ProfileCustomFieldService } from '../../shared/profile-custom-field.service';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wl-profile-view-custom-fields',
  templateUrl: 'custom-field.component.html',
  styleUrls: ['custom-field.component.less'],
    standalone: false
})
export class ProfileViewCustomFieldComponent implements OnInit, OnChanges, OnDestroy {
  private _profileCustomFieldService: ProfileCustomFieldService;
  private _observationService: ObservationService;
  private _profileSubscription: Subscription;

  @Input() public profileId: number;

  public profileCustomFields: Array<ProfileCustomField>;
  public rowCount: number;

  public constructor(profileCustomFieldService: ProfileCustomFieldService, observationService: ObservationService) {
    this._profileCustomFieldService = profileCustomFieldService;
    this._observationService = observationService;
  }

  ngOnInit() {
    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });

    this.loadData();
  }

  ngOnChanges() {
    this.loadData();
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  private profileUpdated(id: number) {
    if (id === this.profileId) {
      this.loadData(true);
    }
  }

  private loadData(forceRefresh?: boolean) {
    this.profileCustomFields = new Array<ProfileCustomField>();
    this.rowCount = 0;

    this._profileCustomFieldService
      .getProfileCustomFieldsForProfileId(this.profileId, forceRefresh)
      .then((data: Array<ProfileCustomField>) => {
        this.rowCount = Math.ceil(data.length / 2);
        this.profileCustomFields = data;
      });
  }
}
